module.exports = __webpack_public_path__ + "static/media/dropbox.c4a911fb.png";